import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { globalHeaderHeightNormal, globalHeaderHeightSmall } from '../GlobalHeader/constants';
import { globalMenuWidthSmall } from '../GlobalMenu/constants';
import { themeColors } from '../JuvareTheme';
import { useHoverSupported, useSmallDevice } from '../hooks';
import { globalInfoHeight } from './constants';
export const GlobalInfo = (props) => {
    const smallDevice = useSmallDevice();
    const hoverSupported = useHoverSupported() && !smallDevice;
    return (React.createElement(Box, { sx: [
            {
                position: 'fixed',
                top: smallDevice ? globalHeaderHeightSmall : globalHeaderHeightNormal,
                right: 0,
                left: 0,
                height: globalInfoHeight,
                paddingLeft: props.menuOpen && hoverSupported ? globalMenuWidthSmall + 16 + 'px' : 2,
                paddingRight: '16px',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                backgroundColor: themeColors.accent.blue.subtlest,
                color: themeColors.accent.blue.bold,
                transition: (theme) => theme.transitions.create('padding-left') + ',' + theme.transitions.create('margin-right', { duration: 400 }),
                zIndex: (theme) => theme.zIndex.appBar - 4,
                '@media print': {
                    display: 'none',
                },
            },
            ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ] },
        React.createElement(InfoOutlinedIcon, null),
        React.createElement(Typography, { variant: 'subtitle2', sx: { flexGrow: 1 } }, props.infoMessage),
        props.infoActionLabel && props.infoActionOnClick && (React.createElement(Button, { sx: { flexShrink: 0, whiteSpace: 'nowrap' }, size: 'small', variant: 'outlined', color: 'inherit', onClick: () => { var _a; return (_a = props.infoActionOnClick) === null || _a === void 0 ? void 0 : _a.call(props); } }, props.infoActionLabel))));
};
